module.exports = __webpack_public_path__ + "static/media/retail.ef694895.jpg";